<template>
  <div v-if="!isChatRoute && !hideFloatChat" class="chat-float-button" @click="goToChat">
    <i class="fa-solid fa-comments"></i>
    <span v-if="unreadCount > 0" class="chat-badge">{{ unreadCount }}</span>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'UnreadChatButton',
  data() {
    return {
      unreadCount: 0,
      polling: null
    }
  },
  computed: {
    isChatRoute() {
      // Cache le bouton sur toutes les routes qui commencent par /chat/
      return this.$route.path.startsWith('/chat/')
    },
    hideFloatChat() {
      return this.$store.state.hideFloatChat
    }
  },
  mounted() {
    this.fetchChatData()
    this.polling = setInterval(() => {
      if (document.visibilityState === 'visible') {
        this.fetchChatData()
      }
    }, 10000)
  },
  beforeDestroy() {
    clearInterval(this.polling)
  },
  methods: {
    async fetchChatData() {
      try {
        const res = await axios.post('/api/v1/manager/check_chat/')
        console.log('Réponse check_chat:', res.data)
        this.unreadCount = res.data.unread || 0
      } catch (e) {
        console.error('Erreur fetch unread:', e)
      }
    },
    goToChat() {
      this.$router.push({ name: 'chat.search_chat', params: { count: this.unreadCount } })
    }
  }
}
</script>

<style scoped>
.chat-float-button {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background-color: #1976d2;
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  z-index: 1000;
}

.chat-badge {
  position: absolute;
  top: -5px;
  right: -5px;
  background: red;
  color: white;
  font-size: 12px;
  font-weight: bold;
  padding: 2px 6px;
  border-radius: 50%;
}
</style>
